module.exports = __webpack_public_path__ + "media/images/sales/smakon/thumb-pricing-01-6a2b542ddcc2d483dc71a08bb2be4266.svg";